import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Utensils, PieChart, Clock } from 'lucide-react';
export function SystemSection() {
  const scrollToPricing = () => {
    const element = document.getElementById('pricing');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const levers = [{
    icon: <Utensils className="w-8 h-8 text-white" data-id="element-171" />,
    title: '1) ORDEN',
    description: 'Lo que comes primero cambia el pico. No es lo mismo empezar con tortilla que empezar con proteína y verdura.',
    color: 'bg-[#C05621]'
  }, {
    icon: <PieChart className="w-8 h-8 text-white" data-id="element-172" />,
    title: '2) PLATO',
    description: 'Porción visual mexicana, sin báscula, sin apps, sin contar todo. Para que puedas comer en casa, fonda o con familia sin improvisar.',
    color: 'bg-[#2F855A]'
  }, {
    icon: <Clock className="w-8 h-8 text-white" data-id="element-173" />,
    title: '3) PASO 10',
    description: "Diez minutos después de comer. Tu 'freno de emergencia' para los días donde no quedó perfecto.",
    color: 'bg-[#D69E2E]' // Amber/Gold
  }];
  return <section className="py-16 px-4 md:py-24 bg-[#FDFBF7]" data-id="element-174">
      <div className="max-w-4xl mx-auto" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-177">
            La solución no es prohibirte. <br data-id="element-178" />
            <span className="text-[#2F855A]" data-id="element-179">Es instalar palancas.</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-180">
            Este PDF funciona porque no depende de "fuerza de voluntad eterna".
            Depende de 3 acciones pequeñas que cambian tu glucosa postcomida y,
            sobre todo, tu sensación de control:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-181">
          {levers.map((lever, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 flex flex-col items-center text-center h-full hover:shadow-xl transition-shadow" data-id="element-182">
              <div className={`${lever.color} w-16 h-16 rounded-full flex items-center justify-center mb-6 shadow-md`} data-id="element-183">
                {lever.icon}
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-184">
                {lever.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-185">
                {lever.description}
              </p>
            </motion.div>)}
        </div>

        {/* "Tried Everything" Subsection */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl p-8 md:p-12 shadow-xl border-l-8 border-[#C05621]" data-id="element-186">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-187">
            ¿Y si yo ya lo intenté todo?
          </h3>
          <div className="prose prose-lg text-gray-700 max-w-none" data-id="element-188">
            <p className="font-medium" data-id="element-189">
              Perfecto. Eso es justamente para quien este método sirve. Porque
              lo que la mayoría intenta son soluciones incompletas:
            </p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 my-6" data-id="element-190">
              <li className="flex items-center bg-gray-50 p-3 rounded-lg" data-id="element-191">
                <span className="w-2 h-2 bg-red-400 rounded-full mr-3" data-id="element-192"></span>
                recetas sin estrategia
              </li>
              <li className="flex items-center bg-gray-50 p-3 rounded-lg" data-id="element-193">
                <span className="w-2 h-2 bg-red-400 rounded-full mr-3" data-id="element-194"></span>
                prohibiciones sin plan social
              </li>
              <li className="flex items-center bg-gray-50 p-3 rounded-lg" data-id="element-195">
                <span className="w-2 h-2 bg-red-400 rounded-full mr-3" data-id="element-196"></span>
                contar carbs sin vida real
              </li>
              <li className="flex items-center bg-gray-50 p-3 rounded-lg" data-id="element-197">
                <span className="w-2 h-2 bg-red-400 rounded-full mr-3" data-id="element-198"></span>
                planes que se caen en la calle
              </li>
            </ul>
            <p className="text-xl font-bold text-gray-900 text-center mt-8" data-id="element-199">
              Aquí no te vendo "recetas mágicas". Te doy un manual de
              decisiones.
            </p>
          </div>

          <div className="mt-10 text-center" data-id="element-200">
            <button onClick={scrollToPricing} className="inline-flex items-center text-[#C05621] font-bold text-lg hover:text-[#9C4221] transition-colors group" data-id="element-201">
              Empieza hoy
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-202" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>;
}